import Image from "next/image";

const PaymentGrid = () => (
  <div>
    <h2 className="text-ink-black mb-4 font-semibold text-lg">
      Accepted payments
    </h2>
    <div className="grid grid-cols-4 gap-2">
      <div className="w-[228px] h-[216px]  rounded-md flex items-center justify-center p-1">
        {/* Lazy and served as webp: it sits in the footer, far below the fold. */}
        <Image
          src="/footer/payment/logo.png"
          alt="Accepted payment methods"
          width={228}
          height={216}
          className="max-w-full max-h-full object-contain"
        />
      </div>
    </div>
  </div>
);

export default PaymentGrid;
